import { PageId } from 'constants/pages'

export const enum PageIdWoofzXmas65 {
  SUBSCRIPTIONS_XMAS_65 = PageId.SUBSCRIPTIONS_XMAS_65,
  CHAT_UPSELL_XMAS_65 = PageId.CHAT_UPSELL_XMAS_65,
  UPSELL_XMAS_65 = PageId.UPSELL_XMAS_65,
  DOWNLOAD_XMAS_65 = PageId.DOWNLOAD_XMAS_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
